import { Button, Tooltip } from "antd";
import { FC } from "react";
import Icon from "../../assets/icons/icon";
import _t from "../../lang/translate";

interface AutoCalcSwitchProps {
  value?: boolean | null;
  onChange?: (v: boolean) => void;
}

const LockSwitch: FC<AutoCalcSwitchProps> = ({ value, onChange }) => {
  const toggleAutoCalculate = () => onChange && onChange(!value);

  return (
    <Tooltip title={_t(value ? "unlock" : "lock")}>
      <Button tabIndex={-1} type="text" shape="circle" className={`btn-grey ${value ? "" : "text-primary-important"}`} onClick={toggleAutoCalculate}>
        <Icon style={{ fontSize: 16 }} name={value ? "lock-closed-outline" : "lock-open-outline"} />
      </Button>
    </Tooltip>
  );
};

export default LockSwitch;
